import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export enum HeaderActionType {
    Save,
    Load,
    Delete,
    PrintPdf,
    PrintCsv,
    ValidatePrintPdf,
    ValidatePrintCsv,
    OpenPrintPdfModal,
    New,
}

export interface HeaderAction {
    type: HeaderActionType;
    payload?: any;
}

@Injectable({ providedIn: 'root' })
export class HeaderActionsService {
    private actionRequestedSource = new Subject<HeaderAction>();
    public actionRequested$ = this.actionRequestedSource.asObservable();

    requestAction(type: HeaderActionType, payload?: any) {
        this.actionRequestedSource.next({ type, payload });
    }
}
